import { Breakpoint, MediaQueries } from '@philips-emr/tws-constants';

const breakpointToMedia = {
  [Breakpoint.XSM]: MediaQueries.XSMALL,
  [Breakpoint.SM]: MediaQueries.SMALL,
  [Breakpoint.MD]: MediaQueries.MEDIUM,
  [Breakpoint.LG]: MediaQueries.LARGE,
};

function getBreakpoint(windowObj: Window = window): string {

  const [breakpoint] = Object.entries(breakpointToMedia).find(
    ([, value]) => windowObj.matchMedia(value).matches
  ) || [''];

  return breakpoint;
}

export default getBreakpoint;
